// extracted by mini-css-extract-plugin
export var cardIcon = "_5u-4";
export var checkboxCard = "_5u-0";
export var checkboxCardSelected = "_5u-3";
export var disabled = "_5u-1";
export var outerBorder = "_5u-2";
export var spacerMedium = "_5u-7";
export var spacerSmall = "_5u-6";
export var spacerXsmall = "_5u-5";